/* Logstash */
export const GET_LOGSTASH_PIPELINES = "GET_LOGSTASH_PIPELINES";
export const GET_LOGSTASH_PIPELINES_SUCCESS = "GET_LOGSTASH_PIPELINES_SUCCESS";
export const GET_LOGSTASH_PIPELINES_ERROR = "GET_LOGSTASH_PIPELINES_ERROR";

export const GET_LOGSTASH_PIPELINE_STATS = "GET_LOGSTASH_PIPELINE_STATS";
export const GET_LOGSTASH_PIPELINE_STATS_SUCCESS =
  "GET_LOGSTASH_PIPELINE_STATS_SUCCESS";
export const GET_LOGSTASH_PIPELINE_STATS_ERROR =
  "GET_LOGSTASH_PIPELINE_STATS_ERROR";
